import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { colors, fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import { useDashMessage } from 'intl/intl.hooks'

interface RecurringShiftsRadioGroupProps {
  labelMessageId?: any
}

const labelContainerStyles = css({
  display: 'flex',
  marginBottom: spacing.X16,
})

const labelTextStyles = css({
  color: colors.GRAYSCALE.X50,
  display: 'block',
  fontSize: fontSize.X15,
  fontWeight: fontWeight.SEMIBOLD,
  marginBottom: spacing.X8,
  marginRight: spacing.X4,
})

const radioStyles = css({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: spacing.X36,
})

export const RecurringShiftsRadioGroup: FunctionComponent<RecurringShiftsRadioGroupProps> = ({
  labelMessageId,
  children,
}) => {
  const label = useDashMessage(labelMessageId)

  return (
    <div>
      {labelMessageId && (
        <div css={labelContainerStyles}>
          <span css={labelTextStyles}>{label}</span>
        </div>
      )}

      <div css={radioStyles}>{children}</div>
    </div>
  )
}
